// extracted by mini-css-extract-plugin
export default {"container":"Suggestion_container__NOQ0G"};